import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {NotFoundScreenComponent} from "./not-found-screen/not-found-screen.component";
import {PageContainerComponent} from "./page-container/page-container.component";
import {NgbDatepickerModule, NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {DatepickerComponent} from "./components/datepicker-component/datepicker.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {TableComponent} from "./components/table-component/table-component";
import {FullLoadingIndicatorComponent} from "./components/full-loading-indicator-component/full-loading-indicator.component";
import { HeaderComponent } from "./header/header.component";
import { RouterModule } from "@angular/router";
import {MultiSelectComponent} from "./components/multi-select-component/multi-select-component";
import {NgMultiSelectDropDownModule} from "ng-multiselect-dropdown";

@NgModule({
    declarations: [
        NotFoundScreenComponent,
        PageContainerComponent,
        DatepickerComponent,
        HeaderComponent,
        TableComponent,
        FullLoadingIndicatorComponent,
        MultiSelectComponent,
    ],
    imports: [
        CommonModule,
        NgbDatepickerModule,
        FormsModule,
        RouterModule,
        NgbModule,
        ReactiveFormsModule,
        NgMultiSelectDropDownModule
    ],
    exports: [
        PageContainerComponent,
        HeaderComponent,
        DatepickerComponent,
        TableComponent,
        MultiSelectComponent
    ]
})
export class CoreModule {

}
